// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Client from "react-dom/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as Stallingsnet$Dashboard from "./Stallingsnet.res.js";

import '../../../src/css/main.scss'
;

import 'chartjs-adapter-date-fns';
import { Chart as ChartJS, registerables } from 'chart.js';
ChartJS.register(...registerables);
;

Stdlib_Option.forEach(Primitive_option.fromNullable(document.querySelector("#root")), element => {
  let root = Client.createRoot(element);
  root.render(JsxRuntime.jsx(Stallingsnet$Dashboard.make, {}));
});

/*  Not a pure module */
